module.exports = __webpack_public_path__ + "static/img/Y1D300.c1911a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Y1D300.png
// module id = nAbh
// module chunks = 2